import React from 'react'
import styled from 'styled-components'
import edit_location_wrapperStyles from './edit_location_wrapper.styles'

const apAtomName = {ap_atom_name: 'apEditLocationWrapperAtom'}

const StyledWrapper = styled(props => <div {...props} />)`
  ${edit_location_wrapperStyles}
`

const EditLocationWrapperAtom: React.FC = function ({children}) {
  return <StyledWrapper {...apAtomName}>{children}</StyledWrapper>
}

export default EditLocationWrapperAtom
